export const VIDEO_REPORT_REASONS: string[] = [
    'watch.report_modal.video_reason.no_relation_to_Kinomap',
    'watch.report_modal.video_reason.content_not_suitable_for_Kinomap',
    'watch.report_modal.video_reason.unsuitable_vehicle',
    'watch.report_modal.video_reason.copyright_rights_issues',
    'watch.report_modal.video_reason.GPS_video_offset',
    'watch.report_modal.video_reason.GPS_accuracy',
    'watch.report_modal.video_reason.confidentiality_problem',
    'watch.report_modal.video_reason.adult_content',
    'watch.report_modal.video_reason.other',
]

export const COMMENT_REPORT_REASONS: string[] = [
    'watch.report_modal.comment_reason.offensive_content',
    'watch.report_modal.comment_reason.spam_or_promotional_content',
    'watch.report_modal.comment_reason.harassment',
    'watch.report_modal.comment_reason.off-topic_comments',
    'watch.report_modal.comment_reason.vulgar_language',
    'watch.report_modal.comment_reason.false_information',
    'watch.report_modal.comment_reason.incitement_to_violence',
    'watch.report_modal.comment_reason.violation_of_community_rules',
]

export const WORKOUT_REPORT_REASONS: string[] = [
    'watch.report_modal.comment_reason.offensive_content',
    'watch.report_modal.comment_reason.spam_or_promotional_content',
    'watch.report_modal.comment_reason.harassment',
    'watch.report_modal.comment_reason.off-topic_comments',
    'watch.report_modal.comment_reason.vulgar_language',
    'watch.report_modal.comment_reason.false_information',
    'watch.report_modal.comment_reason.incitement_to_violence',
    'watch.report_modal.comment_reason.violation_of_community_rules',
]